import { createContext, Dispatch } from "react";

class RequestResponse {
  public code: number | undefined = undefined;
  public msg: string | undefined = undefined;
  public data: NftResData = new NftResData();
}

class NftResData {
  public loading?: boolean = false;
  public buy_collection_count: number | undefined = undefined;
  public buy_cost: number = 0;
  public buy_cost_ratio: number = 0;
  public buy_count: number | undefined = undefined;
  public earned: number = 0;
  public earned_ratio: number = 0;
  public first_follow_timestamp: number | undefined = undefined;
  public nft_value: number = 0;
  public less_hold: HlodItem = new HlodItem();
  public long_hold: HlodItem = new HlodItem();
  public most_expensive: HlodItem = new HlodItem();
  public user: UserItem = new UserItem();

  public top_hold: TopHoldItem = new TopHoldItem();
  public top_profit: TopProfitItem = new TopProfitItem();
  public paper_hand: PaperHand = new PaperHand();
}


class PaperHand {
  public buy_cost: number = 0;
  public sell_cost: number = 0;
  
  public floor_price: number = 0;
  public name: string | undefined = undefined;
  public image_url: string | undefined = undefined;
  public collection_name: string | undefined = undefined;
  public token_id: string = '';
}

class TopHoldItem {
  public balance: number = 0;
  public rank: number = 0;
  public collection_name: string | undefined = undefined;
  public contract_address: string | undefined = undefined;
  public image_url: string | undefined = undefined;
  public name: string | undefined = undefined;
  public slug: string | undefined = undefined;
  public collection_image_url: string | undefined = undefined;
}

class TopProfitItem {
  public buy_cost: number = 0;
  public collection_name: string = '';
  public sell_cost: number | undefined = undefined;
  public floor_price: number | undefined = undefined;
  public contract_address: string | undefined = undefined;
  public image_url: string | undefined = undefined;
  public name: string | undefined = undefined;
  public token_id: string = '';
}
class HlodItem {
  public buy_cost: number =0;
  public buy_timestamp: number = 0;
  public collection_name: string = '';
  public contract_address: string | undefined = undefined;
  public image_url: string | undefined = undefined;
  public name: string | undefined = undefined;
  public sell_cost: number | undefined = undefined;
  public sell_timestamp: number | undefined = undefined;
  public slug: string | undefined = undefined;
  public standard: string | undefined = undefined;
  public token_id: string | undefined = undefined;
  public floor_price: number | undefined = undefined;
}

class UserItem {
  public address: string = "";
  public avatar: string | undefined = undefined;
  public description: string | undefined = undefined;
  public ens: string | undefined = undefined;
  public is_bluechip_owner: boolean | undefined = false;
  public is_whale: boolean | undefined = false;
  public twitter: string | undefined = undefined;
  public twitter_followers: number | undefined = undefined;
  public twitter_name: string | undefined = undefined;
}

export { RequestResponse, NftResData, HlodItem, UserItem };

export const AppContext = createContext<{
  state: NftResData;
  dispatch: Dispatch<{ data: NftResData }>;
}>({
  state: new NftResData(),
  dispatch: () => null,
});
